import request from '@/plugin/axios'

export function ListProgress (id) {
  return request({
    url: '/study/show-progress?id=' + id,
    method: 'get'
  })
}

export function ListProgressBarData (id) {
  return request({
    url: '/study/show-progress-bar?id=' + id,
    method: 'get'
  })
}

export function ListConsistBarData (id) {
  return request({
    url: '/study/show-consist-by-site?id=' + id,
    method: 'get'
  })
}

export function ListSubjectConsist (id) {
  return request({
    url: '/study/show-consist?id=' + id,
    method: 'get'
  })
}

export function ListSiteSdvData (id) {
  return request({
    url: '/study/stat-sdv-by-site?id=' + id,
    method: 'get'
  })
}

export function ListQueryConsist (id) {
  return request({
    url: '/study/stat-query-consist?id=' + id,
    method: 'get'
  })
}
